import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import {getContactName} from "../../components/Form/utils";
import ContactDetails from "../../components/Contacts/ContactDetails";

const ContactsShow = ({contact, contactType, user ,files, notes, backLink}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={getContactName(contact)}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('contacts.back'),
                    href: backLink,
                    color: 'secondary',
                    size: 'small',
                },
                {
                    icon: 'edit',
                    text: i18n.get('contacts.edit'),
                    href: `/contacts/${contactType}/${contact.id}/edit`,
                    size: 'small',
                }
            ]}
        />

        <ContactDetails contact={contact} files={files} notes={notes} user={user} />
    </Layout>
);

export default ContactsShow;
